import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteTag = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 7, height: 7, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillOpacity: 0.35, d: "m4.322 3.499 2.506-2.5A.585.585 0 1 0 6 .17L3.5 2.677 1 .171A.585.585 0 0 0 .172 1l2.506 2.5-2.506 2.5a.583.583 0 0 0 .19.955A.58.58 0 0 0 1 6.827L3.5 4.32 6 6.827a.583.583 0 0 0 .955-.19.58.58 0 0 0-.127-.638z" }));
const ForwardRef = forwardRef(SvgDeleteTag);
export { ForwardRef as ReactComponent };
